module.exports = __webpack_public_path__ + "static/media/jaynee.347f8222.jpg";